
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les 8 meilleures options de ciblage sur Google Ads",
    description:
      "Découvrez avec ALEO les options de ciblage Google Ads : mots-clés, audience, démographique, géographique, etc. Optimisez vos campagnes pour maximiser votre ROI.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
